module.exports = __webpack_public_path__ + "img/315.ca5462eb.gif";